// extracted by css-extract-rspack-plugin
export default {"note":"FilterNote-module__note___M3IJD","icon":"FilterNote-module__icon___tz31n"};